module.exports = __webpack_public_path__ + "static/media/new.196e13f0.png";